module.exports = __webpack_public_path__ + "static/img/woman_glove_6.96566be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/woman_glove_6.png
// module id = UTxx
// module chunks = 0